<template>
    <div class="position-box">
        <div class="cont-box">
            <div class="head">
                <div class="title">{{this.$t('yqm.fx')}}</div>
            </div>
            <div class="item-wrap">
                <router-link class="item-box" to="/wdtd" tag="div">
                    <div class="num">{{own_group_num}}<span class="small"> {{this.$t('user.ren')}}</span></div>
                    <div class="text">{{this.$t('user.wdtd')}}</div>
                </router-link>
                <router-link class="item-box item-box2" to="" tag="div">
                    <div class="num">{{own_cp_num}}<span class="small"> T</span></div>
                    <div class="text">{{this.$t('user.wdyj')}}</div>
                </router-link>
            </div>
            <div class="ewm-wrap">
                <img class="xian" src="@/assets/xian.png" alt="">
                <div class="ewm-box">
                    <div class="ewm">
                        <div class="code" @click="copy($event)">{{user.invite_code}}</div>
                        <!-- <img class="copy" src="@/assets/copy3.png" alt=""> -->
                    </div>
                    <div class="text" @click="copy($event)">{{this.$t('yqm.yqm')}}</div>
                    <div id="imgBox" class="img-box" @click="showCode">
                        <qriously :value="url" :size="118" />
                    </div>
                </div>
                <div class="border border1"></div>
                <div class="border border2"></div>
                <div class="border border3"></div>
                <div class="border border4"></div>
            </div>
            <ul class="line-box">
                <li class="line"></li>
                <li class="text">{{this.$t('yqm.wdyqlj')}}</li>
                <li class="line"></li>
            </ul>
            <div class="input-box">
                <input class="input" v-model="url" disabled type="text">
                <img class="copy" src="@/assets/copy3.png" @click="copy2($event)" alt="">
            </div>
            <!-- <div id="saveImg" class="btn-box" @click="imgDownLoad">
                <img class="btn-save" src="@/assets/baocun.png" alt="">
                <div class="text">{{this.$t('yqm.bcbd')}}</div>
            </div>     -->
        </div>
        <div class="alert-code-wrap" @click="closeCode" v-show="isCode"></div>
        <div class="alert-code-box" v-show="isCode"><qriously :value="url" :size="300" /></div>
        <nav-bar navName='share'></nav-bar>
    </div>
</template>
<script>
import navBar from '@/components/NavBar.vue'
import html2canvas from 'html2canvas';
import VueQriously from 'vue-qriously'
export default {
    name: 'share',
    data () {
        return {
            isShow: true,
            isCode: false,
            uid: '',
            token: '',
            own_group_num: 0,
            own_cp_num: 0,
            url: '',
            user: {
                avatar: require('@/assets/icon_my_tx.jpg'),
                phone:'',
                invite_code: '',
                level: 'V0'
            },
            changMoney: '$0.00'
        }
    },
    mounted() {
        let token = this.token =localStorage.getItem('token');
        this.getMyteam()
        this.getMyEarnings();
    },
    methods: {
      getMyteam(){//团队业绩
        this.$ajax.post('/web/myteam').then((res) => {
          let resData = res.data.data;
          if(res.data.code == 0){
            this.own_group_num = parseInt(resData.team_1) + parseInt(resData.team_2) + parseInt(resData.team_3);
            this.own_cp_num = resData.all_profit;
          }
        }).catch(function(err){
            console.log(err)
        })
      },
      getMyEarnings(){//地址
        this.$ajax.post('/web/getMyEarningsAndPromotion').then((res) => {
          let resData = res.data.data;
          if(res.data.code == 0){
            this.url = resData.link;
          }
        }).catch(function(err){
            console.log(err)
        })
      },
        haibao(){//生成canvas
          html2canvas(document.querySelector("#imgBox"),{
            width: 140,
            height: 140,
          }).then((canvas) => {
            this.canvasToImage(canvas)
          });
        },
        canvasToImage(canvas){//canvas 生成图片
          var image = new Image();
          image.src = canvas.toDataURL("image/png");
                // console.log(window.location.host)
          $('#saveImg').attr('href',image.src)
        },
        imgDownLoad() {
            const tempElem = document.getElementById("imgBox");
            html2canvas(tempElem, {
                useCORS: true // 允许CORS跨域
            }).then(canvas => {
            　　　// 图片触发下载
                const img = canvas.toDataURL("image/jpeg").replace("data:image/jpeg;base64,", "");
                const finalImageSrc = "data:image/jpeg;base64," + img;
                const aElem = document.createElement('a');
                document.body.appendChild(aElem)
                aElem.href = finalImageSrc;
                // 设置下载标题
                aElem.download = "downLoad.png"
                aElem.click();
                document.body.removeChild(aElem);
            })
			// const name = "download";
			// const url = $('#saveImg').attr('href');
			// const suffix = url.substring(url.lastIndexOf("."), url.length);
			// const x = new XMLHttpRequest();
			// x.open("GET", url, true);
			// x.responseType = 'blob';
			// x.onload=function(e) {
			// 	const url = window.URL.createObjectURL(x.response);
			// 	const a = document.createElement('a');
			// 	a.href = url;
			// 	a.download = name;
			// 	a.click()
			// };
			// x.send();
		},
        copy(e){
            let invite_code = this.user.invite_code;
            this.$copyText(invite_code, this.$t('chongbi.fzcg'));
            this.$toast.center(this.$t('chongbi.fzcg'));
        },
        copy2(e){
            let invite_url = this.url;
            this.$copyText(invite_url, this.$t('chongbi.fzcg'));
            this.$toast.center(this.$t('chongbi.fzcg'));
        },
        showCode(){
            this.isCode = true;
        },
        closeCode(){
            this.isCode = false;
        }
    },
    components:{
        navBar
    }
}
</script>
<style scoped>
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 1.2rem;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .36rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .cont-box{
        position: absolute;
        top: 1.2rem;
        bottom: 0;
        width: 100%;
        height: auto;
        padding: 0 .2rem;
        /* background: #0E1530; */
        box-sizing: border-box;
        overflow-y: auto;
    }
    .head{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999;
        width: 100%;
        height: 1.2rem;
        padding: 0 .24rem;
        color: #fff;
        font-size: .52rem;
        line-height: 1.2rem;
        box-sizing: border-box;
        /* background: #0e1530; */
        text-align: center;
    }
    .head .icon{
        position: absolute;
        right: .24rem;
        top: 50%;
        width: .32rem;
        height: .6rem;
        margin-top: -.3rem;
    }
    .photo-box{
        position: relative;
        display: flex;
        align-items: center;
        padding: .38rem 0 .58rem;
    }
    .photo-box .photo{
        width: 1.2rem;
        height: 1.2rem;
        margin-right: .36rem;
        border-radius: .14rem;
    }
    .photo-box .photo-info{
        flex: 1;
    }
    .photo-box .photo-info .t1{
        display: flex;
        align-items: center;
        color: #fff;
        font-size: .45rem;
    }
    .photo-box .photo-info .t1 .level{
        padding-left: .08rem;
        font-size: .48rem;
    }
    .photo-box .photo-info .t1 .img{
        margin-left: .1rem;
        width: .48rem;
        height: .48rem;
    }
    .photo-box .photo-info .t2{
        padding-top: .45rem;
        color: #d7d7d7;
        font-size: .48rem;
    }
    .photo-box .icon{
        position: absolute;
        top: .52rem;
        right: 0;
        width: .56rem;
        height: .52rem;
    }
    .item-wrap{
        display: flex;
        justify-content: space-between;
        /* align-items: center; */
        margin: .48rem 0;
    }
    .item-wrap .item-box{
        width: 4.8rem;
        padding: .42rem .48rem .56rem;
        border-left: .04rem solid #44CFFF;
        background: rgba(26, 36, 63, .5);
        background-size: 100% 100%;
        box-sizing: border-box;
        text-align: center;
    }
    .item-wrap .item-box2{
        border-left: none;
        border-right: .04rem solid #44CFFF;
    }
    .item-wrap .num{
        color: #fff;
        font-size: .66rem;
    }
    .item-wrap .num .small{
        font-size: .45rem;
    }
    .item-wrap .text{
        padding-top: .16rem;
        color: #d7d7d7;
        font-size: .48rem;
    }
    .ewm-wrap{
        position: relative;
        height: 8.4rem;
        padding: .28rem .28rem .36rem .36rem;
        box-sizing: border-box;
    }
    .ewm-wrap .border{
        position: absolute;
    }
    .ewm-wrap .border1{
        left: 0;
        top: 0;
        width: .54rem;
        height: .45rem;
        border-top: 2px solid #44CFFF;
        border-left: 2px solid #44CFFF;
    }
    .ewm-wrap .border2{
        top: 0;
        right: 0;
        width: .54rem;
        height: .45rem;
        border-top: 2px solid #44CFFF;
        border-right: 2px solid #44CFFF;
    }
    .ewm-wrap .border3{
        left: 0;
        bottom: 0;
        width: .54rem;
        height: .45rem;
        border-bottom: 2px solid #44CFFF;
        border-left: 2px solid #44CFFF;
    }
    .ewm-wrap .border4{
        right: 0;
        bottom: 0;
        width: .54rem;
        height: .45rem;
        border-bottom: 2px solid #44CFFF;
        border-right: 2px solid #44CFFF;
    }
    .ewm-wrap .xian{
        width: 100%;
        height: .6rem;
    }
    .ewm-wrap .ewm-box{
        height: 6.8rem;
        margin-top: .18rem;
        color: #40D9FA;
        font-size: .36rem;
        background: rgba(14, 24, 47, .2);
        border-radius: .1rem;
        text-align: center;
    }
    .ewm-wrap .ewm-box .ewm{
        position: relative;
        padding: .34rem 0 0;
        color: #40D9FA;
        font-size: .36rem;
    }
    .ewm-wrap .ewm-box .code{
        flex: 1;
    }
    .ewm-wrap .ewm-box .ewm .copy{
        position: absolute;
        right: 0;
        top: .46rem;
        width: .56rem;
        height: .56rem;
    }
    .ewm-wrap .ewm-box .text{
        padding: .48rem 0;
    }
    .ewm-wrap .ewm-box .img-box{
        position: relative;
        width: 4.2rem;
        height: 4rem;
        margin: auto;
        background: rgba(255,255,255,.2);
        text-align: center;
    }
    .line-box{
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin-top: .46rem;
        color: #40D9FA;
        font-size: .36rem;
    }
    .line-box .line{
        width: 2rem;
        height: 1px;
        background: #40D9FA;
    }
    .btn-box{
        display: block;
        margin-top: .4rem;
        cursor: pointer;
        text-align: center;
    }
    .btn-box .btn-save{
        width: .8rem;
    }
    .btn-box .text{
        padding-top: .36rem;
        color: #fff;
        font-size: .36rem;
    }
    .input-box{
        display: flex;
        align-items: center;
        height: 1.2rem;
        margin: .6rem .2rem .36rem .26rem;
        line-height: 1.2rem;
        border-radius: .1rem;
        background: rgba(26, 36, 63,.5);
    }
    .input-box .input{
        flex: 1;
        padding-left: .2rem;
        color: #d2d2d2;
        font-size: .48rem;
        background: transparent;
    }
    .input-box .copy{
        width: .56rem;
        margin: 0 .28rem;
    }
    .alert-code-wrap{
        position: fixed;
        top: 0;
        bottom: 0;
        z-index: 999;
        width: 100%;
        height: 100%;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .alert-code-box{
        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 1000;
        width: 300px;
        height: 300px;
        background: #fff;
        transform: translate(-50%,-50%);
        text-align: center;
    }
</style>
<style lang="">
    .ewm-wrap .ewm-box .img-box canvas,.alert-code-box canvas{
        position: absolute;
        left: 50%;
        top: 50%;
        background: #fff;
        transform: translate(-50%,-50%);
    }
</style>



// WEBPACK FOOTER //
// src/pages/share.vue